<template>
  <v-card style="background-color: #C8E6C9;">
    <v-col>
      <v-card class="pa-2">
        <div style="margin-bottom: 10px">
          <div class="d-flex align-center mb-3">
            <v-icon color="#5C6BC0" class="mr-2">mdi-account-group-outline</v-icon>
            <span style="font-weight:700; font-size:15px">Techniciens à afficher</span>
          </div>
          <v-text-field class="mb-2" variant="outlined" type="text" v-model="filters" placeholder="Rechercher un technicien..." hide-details
            density="compact" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
          <div class="d-flex flex-wrap" style="gap: 8px; margin-top: 6px; margin-bottom: 6px">
            <v-chip
              v-for="tech in technicienListToShow"
              :key="tech.id"
              :color="selectedTechniciens.includes(tech.title) ? '#4CAF50' : '#ECEFF1'"
              variant="flat"
              label
              :style="{
                color: selectedTechniciens.includes(tech.title) ? 'white' : '#37474F',
                fontWeight: 500,
                cursor: 'pointer'
              }"
              @click="addOrRmvTechnicien(tech.title)"
            >
              <v-icon v-if="selectedTechniciens.includes(tech.title)" size="16" class="mr-1">mdi-check-circle</v-icon>
              {{ tech.title }}
            </v-chip>
            <div v-if="technicienListToShow.length === 0" style="color: #90A4AE; font-size: 13px; padding: 6px">
              Aucun technicien trouvé
            </div>
          </div>
          <v-btn size="small" variant="tonal" color="#5C6BC0" class="mt-2" @click="setSelectedTechniciens">
            <v-icon size="16" class="mr-1">mdi-select-all</v-icon>Tout sélectionner / Tout déselectionner
          </v-btn>
        </div>

        <!-- Couleur des interventions par technicien (remplace la couleur du statut) -->
        <div v-if="selectedTechList.length" class="pt-tc">
          <div class="pt-tc-head">
            <v-icon size="18" color="#5C6BC0">mdi-palette-outline</v-icon>
            <span class="pt-tc-title">Couleur des interventions</span>
            <span class="pt-tc-hint">remplace la couleur du statut sur le planning</span>
          </div>
          <div class="pt-tc-list">
            <v-menu
              v-for="name in selectedTechList"
              :key="name"
              v-model="colorMenu[name]"
              location="bottom start"
              :close-on-content-click="false"
            >
              <template #activator="{ props }">
                <button v-bind="props" type="button" class="pt-tc-chip" :title="'Couleur des interventions de ' + name">
                  <span
                    class="pt-tc-swatch"
                    :class="{ none: !techColors[name] }"
                    :style="techColors[name] ? { backgroundColor: techColors[name] } : {}"
                  ></span>
                  {{ name }}
                  <v-icon size="16" color="#90A4AE">mdi-chevron-down</v-icon>
                </button>
              </template>
              <v-card class="pt-tc-pop">
                <div class="pt-tc-pop-title">{{ name }}</div>
                <div class="pt-tc-palette">
                  <button
                    v-for="c in palette"
                    :key="c"
                    type="button"
                    class="pt-tc-color"
                    :class="{ on: techColors[name] === c }"
                    :style="{ backgroundColor: c }"
                    :title="c"
                    @click="pickColor(name, c)"
                  >
                    <v-icon v-if="techColors[name] === c" size="14" color="white">mdi-check</v-icon>
                  </button>
                </div>
                <div class="pt-tc-pop-foot">
                  <label class="pt-tc-custom" title="Choisir une autre couleur">
                    <input type="color" :value="techColors[name] && techColors[name].charAt(0) === '#' ? techColors[name].slice(0, 7) : '#5C6BC0'" @change="pickColor(name, $event.target.value)" />
                    Autre couleur…
                  </label>
                  <v-btn size="small" variant="text" color="#607D8B" :disabled="!techColors[name]" @click="pickColor(name, '')">
                    Couleur d'origine
                  </v-btn>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
      </v-card>
    </v-col>
    <v-col v-if="isRoot" class="pt-0">
      <v-card class="pa-2">
        <div>
          <div align="center" class="mb-4">
            <h2 style="margin-top: 10px">
              Liste des indisponibilités
              <v-btn color="#C8E6C9" icon="mdi-plus" density="compact" v-if="isEditionOpen == false"
                @click="isEditionOpen = true">
              </v-btn>
            </h2>
            <div v-if="isEditionOpen" style="
                border: solid 1px lightgrey;
                border-radius: 5px;
                padding: 10px;
                margin: 10px 5px;
              ">
              <v-col>
                <v-row>
                  <v-col cols="6">
                    Début<Datepicker v-model="dateStart" locale="fr" format="dd/MM/yyyy HH:mm" :clearable="false"
                      :cancelText="'Fermer'" :selectText="'Valider'"></Datepicker>
                  </v-col>
                  <v-col cols="6">
                    Fin<Datepicker v-model="dateEnd" locale="fr" format="dd/MM/yyyy HH:mm" :clearable="false"
                      :cancelText="'Fermer'" :selectText="'Valider'"></Datepicker>
                  </v-col>
                  <v-col cols="6">
                    Technicien
                    <v-select variant="outlined" hide-details density="compact" v-model="selectedTech"
                      :items="technicienList" style="
                        width: 100%;
                        height: 35px;
                        border-color: lightgrey;
                        border-radius: 3px;
                      ">
                    </v-select>
                  </v-col>
                  <v-col cols="6">
                    Type
                    <v-select variant="outlined" hide-details density="compact" v-model="selectedType" :items="typeList"
                      style="
                        width: 100%;
                        border-color: lightgrey;
                        border-radius: 3px;
                      ">
                    </v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- <tr> -->
              <!-- <th>
                  <div style="margin: 0px 5px">
                    Début<Datepicker v-model="dateStart" locale="fr" format="dd/MM/yyyy HH:mm" :clearable="false"
                      :cancelText="'Fermer'" :selectText="'Valider'"></Datepicker>
                  </div>
                </th>
                <th>
                  <div style="margin: 0px 5px">
                    Fin<Datepicker v-model="dateEnd" locale="fr" format="dd/MM/yyyy HH:mm" :clearable="false"
                      :cancelText="'Fermer'" :selectText="'Valider'"></Datepicker>
                  </div>
                </th> -->
              <!-- <th>
                  <div style="margin: 0px 5px">
                    Technicien
                    <v-select variant="outlined" hide-details density="compact" v-model="selectedTech"
                      :items="technicienList" style="
                        width: 100%;
                        height: 35px;
                        border-color: lightgrey;
                        border-radius: 3px;
                      ">
                    </v-select>
                  </div>
                </th> -->
              <!-- <th>
                  <div style="margin: 0px 5px">
                    Type
                    <v-select variant="outlined" hide-details density="compact" v-model="selectedType" :items="typeList"
                      style="
                        width: 100%;
                        border-color: lightgrey;
                        border-radius: 3px;
                      ">
                    </v-select>
                  </div>
                </th> -->
              <!-- </tr> -->
              <div style="padding-top: 10px">
                <v-btn class="button-state" style="
                    background-color: #2e7d32;
                    font-size: 15px;
                    padding: 5px;
                    margin: 2px;
                    color: white;
                    cursor: pointer;
                  " @click="creatNotDispo()">
                  Ajouter
                </v-btn>
                <v-btn class="button-state" style="
                    background-color: #d84315;
                    font-size: 15px;
                    padding: 5px;
                    margin: 2px;
                    color: white;
                    cursor: pointer;
                  " @click="cancelCreationDispo()">
                  Annuler
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <v-card class="mb-3" variant="flat" style="border: solid 1px grey;">
          <v-text-field hide-details label="Rechercher une indisponibilitée..." v-model="searchDispo"
            clearable></v-text-field>
        </v-card>

        <v-card variant="flat">
          <Vue3EasyDataTable table-height="250" hide-rows-per-page	 :headers="headers" :items="getTechnicienListAvailable"
            empty-message="Aucun commentaire trouvé">
            <template #item-startTimestamp="item">
              <div>
                {{ item.DEBUT }}
              </div>
            </template>
            <template #item-endTimestamp="item">
              <div>
                {{ item.FIN }}
              </div>
            </template>
            <template #item-delete="item">
              <div v-if="isRoot" align="center" class="pa-2">
                <!-- <v-btn density="compact" icon variant="tonal" style="color: red; font-size: 14px; cursor: pointer"
                  @click="removeNotDispo(item)">
                  <v-icon>mdi-close</v-icon>
                </v-btn> -->
                <v-btn density="compact" icon variant="tonal" style="color: red; font-size: 14px; cursor: pointer"
                  @click="removeNotDispo(item)">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

              </div>
            </template>
          </Vue3EasyDataTable>
        </v-card>

      </v-card>
    </v-col>
    <div class="d-flex justify-center pa-3">
      <v-btn color="#5C6BC0" variant="flat" style="color:white" @click="closeModal">
        <v-icon size="18" class="mr-1">mdi-check</v-icon>Valider et fermer
      </v-btn>
    </div>
  </v-card>
</template>

<script>

import Vue3EasyDataTable from "vue3-easy-data-table";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import planningTechnicien from "../core/index";
import moment from "moment";

export default {
  data() {
    return {
      searchDispo:"",
      headers: [
        { text: "Début", value: "startTimestamp", sortable: true },
        { text: "Fin", value: "endTimestamp", sortable: true },
        { text: "Technicien", value: "TECHNICIEN", sortable: true },
        { text: "Type", value: "TYPE", sortable: true },
        { text: "", value: "delete" },
      ],
      typeList: [
        "CP ( congé payé )",
        "RTT",
        "CSS ( congé sans solde )",
        "AEX ( absence exceptionnelle )",
        "CM ( congé maladie )",
        "Autre",
      ],
      isEditionOpen: false,
      dateStart: "",
      dateEnd: "",
      selectedTech: "",
      selectedType: "",
      filters: "",
      colorMenu: {},
      // Couleurs proposées (texte lisible ajusté automatiquement sur le planning).
      palette: [
        "#E53935", "#D81B60", "#8E24AA", "#5E35B1", "#3949AB", "#1E88E5", "#039BE5",
        "#00ACC1", "#00897B", "#43A047", "#7CB342", "#C0CA33", "#FDD835", "#FFB300",
        "#FB8C00", "#F4511E", "#6D4C41", "#757575", "#546E7A", "#263238",
      ],
    };
  },
  components: {
    Vue3EasyDataTable,
    Datepicker,
  },
  props: {
    isRoot: {},
    technicienList: {},
    technicienListAvailable: {},
    selectedTechniciens: {},
    addOrRmvTechnicien: {},
    setSelectedTechniciens: {},
    setTechnicienAvailable: {},
    updateTechToShow: {},
    techColors: { type: Object, default: () => ({}) },
    setTechColor: { type: Function, default: () => {} },
  },
  mounted() {
    let that = this;
    planningTechnicien.getIndisponibilityType(function (data) {
      if (data.code == 0) {
        that.typeList = data.data.data.map((val) => val.fieldData.Name);
      }
    });
  },
  watch: {
    isEditionOpen(val) {
      if (val == true) {
        this.dateStart = moment()
          .set({ hour: 8, minute: 0 })
          .format("MM/DD/YYYY HH:mm");
        this.dateEnd = moment()
          .set({ hour: 18, minute: 0 })
          .format("MM/DD/YYYY HH:mm");
        this.selectedType = this.typeList[0];
        this.selectedTech = this.technicienList[0].title;
      }
    },
  },
  computed: {
    // Techniciens sélectionnés (ordre de la liste), pour le choix des couleurs.
    selectedTechList() {
      return (this.technicienList || [])
        .map((t) => t.title)
        .filter((n) => this.selectedTechniciens.includes(n));
    },
    getTechnicienListAvailable() {
      let list = [];
      for (let i = 0; i < this.technicienListAvailable.length; i++) {
        let value = this.technicienListAvailable[i];
        let id = moment(value.start).format("DD/MM/YYYY HH:mm") + moment(value.end).format("DD/MM/YYYY HH:mm") + value.TECHNICIEN + value.TYPE

        if (this.searchDispo == undefined || this.searchDispo.length == 0 || (this.searchDispo && id.toLocaleLowerCase().includes(this.searchDispo.toLocaleLowerCase()))) {
          value.DEBUT = moment(value.start).format("DD/MM/YYYY HH:mm");
          value.FIN = moment(value.end).format("DD/MM/YYYY HH:mm");
          value.startTimestamp = moment(value.start).format("x");
          value.endTimestamp = moment(value.end).format("x");

          list.push(value);
        }
      }
      return list;
    },
    technicienListToShow() {
      let techList = this.technicienList;
      techList = techList.sort(function (a, b) {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return 0;
      });

      if (this.filters == "") {
        return techList;
      } else {
        let filteredTech = [];
        for (let i = 0; i < techList.length; i++) {
          if (techList[i].id.toLowerCase().includes(this.filters.toLowerCase()))
            filteredTech.push(techList[i]);
        }
        return filteredTech;
      }
    },
  },
  methods: {
    creatNotDispo() {
      let data = {
        DEBUT: moment(this.dateStart).format("MM/DD/YYYY HH:mm"),
        FIN: moment(this.dateEnd).format("MM/DD/YYYY HH:mm"),
        TECHNICIEN: this.selectedTech,
        TYPE: this.selectedType,
        state: 1,
      };
      let that = this;
      planningTechnicien.set_technicien_available_liste_by_key(
        "",
        data,
        function () {
          that.setTechnicienAvailable();
        }
      );
      this.cancelCreationDispo();
    },
    removeNotDispo(data) {
      let that = this;
      planningTechnicien.set_technicien_available_liste_by_key(
        data["Clé primaire"],
        { state: 0 },
        function () {
          that.setTechnicienAvailable();
        }
      );
    },
    cancelCreationDispo() {
      this.isEditionOpen = false;
      this.dateStart = undefined;
      this.dateEnd = undefined;
      this.selectedTech = undefined;
      this.selectedType = undefined;
    },
    pickColor(name, color) {
      this.setTechColor(name, color);
      this.colorMenu[name] = false;
    },
    closeModal() {
      this.updateTechToShow();
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save", {
        e: this.data.e,
        Techniciens_Nom: this.data.calendarTech,
      });
    },
  },
};
</script>

<style>
.planning-technicien .colorHover:hover {
  background-color: lightgrey;
}

/* Couleur des interventions par technicien */
.pt-tc {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #dfe4ea;
}
.pt-tc-head {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}
.pt-tc-title {
  font-weight: 700;
  font-size: 14px;
  color: #263238;
}
.pt-tc-hint {
  font-size: 12px;
  color: #90a4ae;
}
.pt-tc-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.pt-tc-chip {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid #dfe4ea;
  background: #f7f9fb;
  color: #37474f;
  font-size: 13px;
  font-weight: 600;
  padding: 5px 8px 5px 6px;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.12s ease;
}
.pt-tc-chip:hover {
  border-color: #5c6bc0;
}
.pt-tc-swatch {
  width: 18px;
  height: 18px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.pt-tc-swatch.none {
  background: repeating-linear-gradient(45deg, #eceff1, #eceff1 3px, #ffffff 3px, #ffffff 6px);
}
.pt-tc-pop {
  padding: 10px 12px;
  border-radius: 12px !important;
  width: 270px;
}
.pt-tc-pop-title {
  font-size: 12px;
  font-weight: 800;
  color: #546e7a;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  margin-bottom: 8px;
}
.pt-tc-palette {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 6px;
}
.pt-tc-color {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 2px solid transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.1s ease;
}
.pt-tc-color:hover {
  transform: scale(1.1);
}
.pt-tc-color.on {
  border-color: #263238;
}
.pt-tc-pop-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  margin-top: 10px;
}
.pt-tc-custom {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12.5px;
  font-weight: 600;
  color: #5c6bc0;
  cursor: pointer;
}
.pt-tc-custom input[type="color"] {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid #dfe4ea;
  border-radius: 6px;
  background: none;
  cursor: pointer;
}
</style>